import { useTranslation } from 'next-i18next';
import Link from 'next-translate-routes/link';
import type { FC } from 'react';

import { Button, Icon } from '@/components';

interface VerificationCardProps {
  title: string;
  description: string;
  action?: {
    title: string;
    callback: () => void;
  };
}
export const VerificationCard: FC<VerificationCardProps> = ({
  title,
  description,
  action,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-between gap-4 rounded-3xl bg-blue-500 px-6 pb-6 pt-5 md:flex-row md:items-center md:gap-12 md:pb-5 lg:flex-col lg:items-start lg:gap-4 lg:pb-6">
      <div className="flex gap-3">
        <Icon
          name="verification"
          className="size-12 shrink-0 stroke-transparent"
        />
        <div>
          <p className="h6 text-white">{title}</p>
          <p className="body3 mt-1 text-blue-100">{description}</p>
        </div>
      </div>
      {action ? (
        <Button
          color="secondary"
          className="h-[44px] w-full"
          props={{ onClick: action.callback }}
        >
          {action.title}
        </Button>
      ) : (
        <Link
          className="w-full shrink-0 md:w-max lg:w-full"
          href={{
            pathname: '/profile/compliance/',
            query: {
              success_redirect: `/profile/`,
            },
          }}
        >
          <Button color="secondary" className="h-[44px] w-full">
            {t('verification_card.action')}
          </Button>
        </Link>
      )}
    </div>
  );
};
